import { render, staticRenderFns } from "./ShelfPreview.vue?vue&type=template&id=20d48319&scoped=true"
import script from "./ShelfPreview.vue?vue&type=script&lang=js"
export * from "./ShelfPreview.vue?vue&type=script&lang=js"
import style0 from "./ShelfPreview.vue?vue&type=style&index=0&id=20d48319&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d48319",
  null
  
)

export default component.exports